import { createStore } from 'vuex'
import user from './modules/user'
import appData from './modules/appData'

export default createStore({
  // state: {
  // },
  // getters: {
  // },
  // mutations: {
  // },
  // actions: {
  // },
  modules: {
    user,
    appData
  }
})
